import { Translation } from 'src/types';

const translations: Translation = {
  translation: {
    Buttons: {
      back: '返回',
      changePassword: '更改密码',
      copiedVaultId: '已复制！',
      copyVaultID: '复制Vault ID',
      create: '创建',
      next: '下一步',
      notSure: '我不确定',
      signUp: '注册',
      submit: '提交',
      updatePassword: '更新密码',
    },
    Errors: {
      createReportFailed: '创建报告失败。',
    },
    ReportStatus: {
      CLOSED: '已关闭',
      INVESTIGATING: '正在调查',
      NEW: '已提交',
      READ: '阅读',
    },
    general: {
      navbar: {
        caseSettings: '案例设置',
        changePassword: '更改密码',
        logOut: '注销',
        notifications: '通知',
        notificationsDrawer: {
          appFileScanFailed: '一个文件未通过安全检查',
          appReportMatch: '您的GoTogether记录已经匹配成功',
          appReportReassigned: '已经分配了一位新的案件经理',
          case: '案例',
          caseAssigned: '分配给你的案例',
          caseImporterJobCompleted: {
            PartialSuccess: '您的案件导入已完成，但出现了错误。',
            failure: '您的案例导入失败',
            success: '您的案例导入已成功完成',
          },
          caseLinked: '案例链接',
          caseTeamInvite: '添加到案例',
          caseUnlinked: '案件未链接',
          dataSanitisation: '报告详细信息已更新',
          emptyDescription: '稍后查看新的通知',
          emptyTitle: '你已经赶上了',
          importId: '导入ID：',
          learnMore: '了解更多',
          markAllAsRead: '将全部标记为已读',
          newMessage: '新消息',
          newReport: '收到新报告',
          permissionRemoved: '从案例中移除',
          postSSubmissionFile: '添加的证据文件(s)',
          report: '报告',
          reportAssigned: '分配给你的报告',
          reportStatusChange: '报告状态已更改',
          reporterAnonymised: '您的详细信息已被匿名化',
          reporterReportSubmitted: {
            subtitle: '我们建议您保存一份报告的副本',
            title: '提交的报告',
          },
          mitigationPlanReminder: '需要批准缓解计划',
          staleCase: '未处理的案例',
        },
        privacyStatement: '隐私声明',
        reporter: {
          myReports: '我的报告',
        },
        settings: '设置',
        technicalSupport: '技术支持',
        title: '账户',
      },
      time: {
        day: '白天',
        days: '天数',
        hour: '小时',
        hours: '小时',
        minute: '分钟',
        minutes: '分钟',
        second: '第二',
        seconds: '秒钟',
      },
    },
    public: {
      ChatContainer: {
        anonymousLabel: '匿名',
        autoTranslate: '自动翻译默认是关闭的。',
        backToMessages: '返回到消息',
        caseSettings: '案例设置。',
        changeInProfile:
          '如果你希望更改此设置，你可以在你的个人资料中进行操作。',
        deletedByMessage: '由 {{author}} 删除',
        deletedMessageLabel: '此消息已被删除',
        description:
          '当自动翻译开启时，所有报告信息都将基于您浏览器上选择的默认语言使用AI自动翻译。',
        descriptionSecondHalf:
          '所有消息的原始版本都会被保留，并可以在聊天中找到。',
        messagePlaceholder: '开始打字...',
        messageSettings: '消息设置。',
        originalMessages: '原文',
        showMoreBanner: '了解更多关于自动翻译的信息',
        titlev2: '阅读您首选语言中的所有消息。',
        translatedMessageLabel: '翻译后的信息',
        translatedMessages: '翻译',
        understood: '明白了',
      },
      Country: {
        description: '您在哪个国家工作？',
        header: '您在哪个国家工作？',
        noOptions: '未找到国家',
        other: '其他',
        placeholder: '搜索国家...',
      },
      CreatePublicReport: {
        createReport: '创建新报告',
        helpPage: '转到我们的帮助页面',
        loginToOpr: '登录以追踪报告',
        or: '或者',
        passwordPlaceholder: '输入密码',
        phoneNumberLoginFailed: '登录失败，电话号码/密码错误',
        phoneNumberPlaceholder: '输入您的电话号码',
        phoneNumberTooltip: '输入您用来联系VaultTalk的电话号码',
        pinPlaceholder: '输入密码',
        reportIntroductionParagraph1:
          '当报告一起事件时，我们会向您提出几个问题，以便帮助您记录您的经历。',
        reportIntroductionParagraph2:
          '在您提交之前，您有选择保持匿名以保护您的隐私的选项。',
        reportIntroductionParagraph3:
          '在您提交后，您可以随时登录查看报告进度并与案件经理交谈。',
        reportIssue: '报告一个问题',
        usernameLoginFailed: '登录失败，用户名/密码错误',
        validationError: {
          publicReport: {
            relationshipToCompanyRequired: '需要与公司的关系',
            reportedCategoryRequired: '要求报告类别',
          },
        },
        vaultId: 'Vault ID',
        vaultIdPlaceholder: '输入您的电子邮件或Vault ID',
        vaultIdTooltip:
          '对于匿名报告，Vault ID是字母数字。如果报告不是匿名的，Vault ID就是您的电子邮件地址。',
        vaultTalk: 'VaultTalk',
        yourPassword: '您的密码',
        yourPhoneNumber: '您的电话号码',
        yourPin: '您的6位数密码',
        yourVaultId: '您的Vault ID',
      },
      CustomHeader: {
        companyLogo: '公司标志',
        openReporting: '开放报告',
        userSettings: '用户设置',
      },
      Date: {
        approximateDescription: '您还记得该事件发生的大概日期吗？',
        approximatePlaceholder: '示例：6 个月前 / 去年 / 去年 11 月',
        cancel: '取消',
        clear: '清除',
        description: '您还记得该事件发生的日期吗？',
        header: '事件发生在哪一天？',
        ok: '确定',
        placeholder: '示例：2020 年 6 月 21 日',
      },
      Description: {
        whatHappened: '发生了什么？',
        whatHappenedPlaceholder: '用您自己的话...',
        whatHappenedText: '用您自己的话，描述发生了什么',
      },
      Details: {
        disclaimer:
          '这些细节将会在你的报告中被披露。如果你希望保持匿名，请确保它们不包含任何可以识别你身份的信息。',
        emailPlaceholder: '电子邮件（可选）',
        fullNamePlaceholder: '全名（可选）',
        header: '您的详细资料',
        nonAnonSubtitle:
          '请提供您的姓名或电子邮件地址。如果您想接收有关此报告的通知，请在下方添加适当的电子邮件地址。',
        nonOptionalEmailPlaceholder: '电子邮件',
        nonOptionalFullNamePlaceholder: '全名',
        subtitle:
          '如果你想接收有关此报告的通知，请在下方添加一个适当的电子邮件地址。',
      },
      Emotion: {
        description: '它给您的感觉如何？影响是什么？',
        header: '影响是什么？',
        placeholder: '开始输入...',
      },
      Evidence: {
        addedHeading: '已添加',
        deletedMessage: '被删除了',
        deletedStatus: '已删除',
        failedToOpenFileMessage: '无法打开文件。请再试一次。',
        fileStatuses: {
          infectedUpload: '被安全检查标记',
          passedUpload: '通过安全检查',
          pendingUpload: '正在进行安全检查',
          readyForDownload: '准备下载',
        },
        mobileErrorMessage: '标记的文件：向您的案件经理发送消息',
        nameHeading: '名称',
        statusHeading: '状态',
        tableTitle: '证据',
        webErrorMessage:
          '被标记的文件：如果您的文件已被标记，请向案件经理发送消息',
      },
      FileUpload: {
        addFiles: '添加文件',
        addMoreFiles: '添加更多文件',
        confirm: '确认',
        description:
          '将文件添加为证据可以帮助您的案件经理提高解决效率。如果您希望保持匿名，请考虑文件内容（包括文件元数据），并尊重其他个人的权利和适用的法律。',
        dragDrop: '将文件拖放到此处或者',
        errorMessage:
          '由于网络错误，文件失败。请点击以下链接向您的案件经理求助。',
        fileLimit: '每个文件大小限制：100MB',
        fileUploadLimitText: '您只能上传10个文件',
        header: '添加证据',
        helpArticle: '帮助文章',
        highlighted: '浏览文件',
        information: '支持的文件类型',
        moreInformation: '有关更多信息，请参见此处 <a>帮助文章</a>',
        postSubmissionErrorMessage:
          '由于系统错误，我们无法上传您的文件。请再次选择“确认”。',
        tooltipAudio: '音频：',
        tooltipAudioOptions: '.ogg, .wav, .wma',
        tooltipDocuments: '文件:',
        tooltipDocumentsOptions:
          '.ps, .docx, .doc, .pptx, .ppt, .xlsx, .xls, .dcm, .pdf',
        tooltipImage: '图像：',
        tooltipImageOptions:
          '.png, .apng, .jpg, .jpeg, .pjpeg, .svg, .gif, .tiff, .tif, .bmp, .psd, .avif',
        tooltipText: '文本:',
        tooltipTextOptions: '.txt，.csv，.html，.xml',
        tooltipVideo: '视频：',
        tooltipVideoOptions: '.mp4、.mov、.mp1s、.asf',
        uploadErrors: {
          invalidFileSize: '文件太大',
          invalidFileType: '不支持的文件类型：{{extension}}',
          systemError: '系统错误',
          tooManyFiles: '文件的最大数量是{{maxFiles}}',
        },
        uploadFiles: '上传文件',
      },
      Loading: {
        loading: '请等待，我们正在向案件经理提交您的报告...',
        postSubmissionLoading: '请等待我们提交您的文件...',
      },
      Location: {
        description: '事件是在哪里发生的？',
        header: '事件是在哪里发生的？',
        placeholder: '示例：在办公室',
      },
      MessageListBox: {
        messageCaseManager: '消息案件经理',
        report: '报告 {{displayReportId}} {{submissionType}}',
      },
      MessageSettings: {
        enableTranslationLabelDisabled: '翻译已禁用',
        enableTranslationLabelEnabled: '启用翻译',
        enableTranslationsDescription:
          '启用自动翻译并用您喜欢的语言阅读所有报告信息。翻译语言基于您设备上选择的语言。',
        enableTranslationsHeader: '开启报告消息的自动翻译功能',
        enableTranslationsSubDescriptionv2:
          '您可以在每个聊天中切换原文和翻译语言。',
        updateTranslationFailed: '更新翻译失败',
        updateTranslationSuccess: '翻译设置更新成功',
      },
      Password: {
        changePasswordHeader: '更改密码',
        createNewPassword: '请创建一个新密码',
        createPasswordHeader: '您的密码',
        currentPasswordPlaceholder: '输入当前密码',
        description: '有效密码必须至少有 9 个字符，包括一个大写字母和一个数字',
        enterCurrentPassword: '请输入您当前密码',
        forgottenPasswordInstructions:
          '输入您的字母数字Vault ID（不是您的电子邮件地址）和电子邮件地址以重置您的密码。',
        newDescription:
          '创建一个强大的密码以保护您的账户安全。开始输入以查看下方的指南。',
        passwordPlaceholder: '创建密码',
        passwordResetRequestedDescription:
          '如果您的Vault ID在我们的系统中存在，您将收到一封带有重置密码指南的电子邮件。',
        passwordResetRequestedHeader: '请求密码重置链接',
        reenterPlaceholder: '再次输入密码',
        subtitle: '创建一个密码以提交此报告并在今后进行访问',
        yourVaultId: '您的Vault ID',
        yourVaultIdPlaceholder: '输入您的Vault ID（例如 {{exampleId}}）',
      },
      Perpetrators: {
        description: '您是在举报一个特定的人还是多个人？您能说出或描述他们吗？',
        header: '涉及的人员',
        placeholder: '开始输入并使用逗号来添加多个名称或描述',
      },
      PoweredByVault: '由 {{company}} 提供技术支持',
      PrivacyStatement: '产品隐私声明',
      PublicMessageList: {
        myMessages: '我的消息',
      },
      PublicMoreEvidence: {
        additionalEvidenceHeader: '已将证据添加到现有报告中',
        backToReportId: '返回报告ID：{{reportId}}',
        description:
          '将文件添加为证据可以帮助您的案件经理提高解决效率。如果您希望保持匿名，请考虑文件内容（包括文件元数据），并尊重他人的权利和适用的法律。有关更多信息，请查看此。 <a>帮助文章</a>',
        header: '将额外的证据添加到报告中',
        vaultTalkOpenCaseHeader: '将证据添加到你的报告中',
      },
      PublicReport: {
        anonymous: '匿名',
        backToReports: '返回到报告',
        skipped: '跳过',
      },
      PublicReportCard: {
        addEvidence: '添加额外证据',
        messageCaseManager: '消息案件经理',
        reportId: '报告 ID：',
        submitted: '已提交',
        vaultTalkClosedCaseCTA: '查看证据',
        vaultTalkOpenCaseCTA: '添加证据',
        viewAdditionalEvidence: '查看额外证据',
        viewReport: '查看报告',
      },
      PublicReportsList: {
        reportingSystem: '报告系统',
      },
      Question: {
        placeholder: '开始输入...',
        question: '提供详细信息',
        questionText: '请与我们分享您的顾虑，更新或查询。',
      },
      Relationship: {
        header: '您与本组织的关系',
        tellUsAbout: '请告诉我们您与该组织的关系。',
      },
      ResponsiveNavMenu: {
        messages: '我的消息',
        reports: '我的报告',
      },
      Site: {
        description: '您在哪个站点工作？',
        header: '您在哪个站点工作？',
        noOptions: '未找到站点',
        other: '其他',
        placeholder: '搜索站点...',
      },
      SpamPuzzle: {
        dialog: '继续前，请完成此谜题',
      },
      SubmissionTypes: {
        reportIssue: '选择一个类别',
        whatType: '选择最能描述您报告的类别 ',
      },
      SubmitSuccess: {
        category: '<bold>类别：</bold> {{category}}',
        country: '<bold>国家:</bold> {{country}}',
        dateSubmitted: '<bold>提交日期：</bold> {{date}}',
        recordYourVaultID: '请记住此登录信息',
        successInformation: '更多信息',
        successMessage:
          '您的报告已提交并已准备好进行审查。任何需要关注的附件文件将在登陆后被标记。请在下面登陆以查看报告更新并给您的案件经理发送信息。',
        successSanitationMessage:
          '将其复制一份保存以作备份，并妥善保管您的Vault-ID——您会需要它来获取更新和向案件经理发送消息。',
        successSanitationTagline: '您的报告已提交并安全存储。',
        successThankYou: '感谢您的报告！',
        viewReport: '查看报告',
      },
      Time: {
        approximateDescription: '您还记得该事件发生的大概时间吗？',
        approximatePlaceholder: '示例：上午、下午',
        description: '您记得该事件发生的时间吗？',
        header: '事件是什么时候发生的？',
        invalidTime: '时间格式必须是 HH:MM（小时:分钟）',
      },
      UserSettingsDialog: {
        changePassword: '更改密码',
        closeDialog: '关闭对话',
        logout: '登出',
        messageSettings: '消息设置',
        userSettings: '用户设置',
      },
      Witnesses: {
        description: '您有没有告诉其他人，或者有没有人看到发生了什么？',
        header: '有证人吗？',
        placeholder: '开始输入...',
      },
    },
    reporting: {
      MessageSlideIn: {
        confirmButton: '发送消息',
        title: '消息案例管理员',
        translationHeader: '了解更多关于自动翻译的信息',
      },
      ReportCard: {
        addEvidence: '添加证据',
        submissionModeVia: '通过{{submissionMode}}',
        viewEvidence: '查看证据',
      },
      ReportList: {
        yourReports: '你的报告',
      },
      ReportingActivate: {
        buttonText: '继续',
        description:
          '如果贵组织已为您注册了一个帐户，我们将向您发送一封带有完成设置指令的电子邮件。',
        emailInput: '电子邮件',
        header: '输入您的工作电子邮件',
        successAccount:
          '如果您的组织为您注册了一个账户，我们将向您发送一封带有完成设置指南的电子邮件。',
        successEmail:
          '如果你没有立即看到它，请等待几分钟并刷新你的电子邮件收件箱。',
        successHeading: '谢谢你',
      },
      ReportingAddEvidence: {
        descriptionHeader: '将证据添加到你的报告中',
        descriptionText:
          '将文件添加为证据可以帮助你的案件经理提高解决效率。如果你希望保持匿名，请考虑文件内容（包括文件元数据），并尊重他人的权利和适用的法律。有关更多信息，请查看此<a>帮助文章</a>。',
        emptyMessage: '没有上传额外的证据',
      },
      ReportingChangePassword: {
        back: '后退',
        description:
          '创建一个强大的密码以保护您的账户安全。开始输入以查看下面的指南。',
        errorToast: '无法创建密码，无效的令牌。',
        header: '更改密码',
        incorrectCurrentPassword: '当前密码错误。请检查后再试一次。',
        invalidToken: '无效的令牌',
        passwordUpdated: '密码已更新',
        passwordUpdatedDescription:
          '您的密码已成功更新。感谢您采取此步骤保护您的数据安全！',
        passwordUsedBefore: '不允许重复使用密码',
        passwordUsedBeforeDescription:
          '为了您的安全，您不能重复使用您最近的六个密码。请选择一个新的、独特的密码以保护您的账户安全并再试一次。',
        toastDescription:
          '您的密码已成功更新。感谢您采取这一步来保证您的数据安全！',
        toastMessage: '密码已更新',
        updatePasswordCTA: '更新密码',
      },
      ReportingConnect: {
        cancelButton: '取消',
        connectButton: '连接',
        disclaimer:
          '将您的Slack账户与您的Vault账户连接可以确保安全和私密的连接。<br /><br />通过连接，您可以直接在Slack中报告不当行为或提出问题。连接后，您总是有选择匿名报告的选项。您的隐私和安全是我们的首要任务。',
        heading:
          'Vault Platform正在请求许可以访问您的{{organisationName}} Slack账户',
        listHeading: 'Vault将能够做什么？',
        permissionIdentity: {
          extraInfo: 'Vault将有能力查看您的Slack用户身份',
          heading: '查看用户身份信息',
        },
        permissionNotifications: {
          extraInfo:
            'Vault将能够向您的Slack账户发送通知，关于提交的报告或问题的任何更新。',
          heading: '向您发送通知',
        },
        permissionOverview: {
          extraInfo: 'Vault将在主页上显示所有提交的概述',
          heading: '提交概览',
        },
        permissionSubmitReport: {
          extraInfo:
            '这将授予Vault权限，可以直接通过Slack向您的组织提交报告或提问。',
          heading: '代表您提交报告或提问',
        },
        successfulConnectionDescription:
          '您的Vault账户和Slack账户现在已经连接。您现在可以关闭此标签页并返回到Slack。',
        successfulConnectionHeading: '成功连接',
        unsuccessfulConnectionDescription:
          '发生了一些错误。请关闭此标签页并返回到Slack重试。',
        unsuccessfulConnectionHeading: '连接失败',
      },
      ReportingForgotPassword: {
        description:
          '输入与您的账户关联的电子邮件地址，我们将向您发送一个重置密码的链接。',
        heading: '忘记密码',
        invalidTokenError: '无法创建密码，令牌无效。',
        passwordReuseError: '不允许重复使用密码',
        passwordReuseErrorDescription:
          '为了您的安全，您不能重复使用最近的六个密码。请选择一个新的、独一无二的密码来保护您的账户安全，并再次尝试。',
        sendLink: '发送重置链接',
        sendLinkFailure: '出了些问题',
        sendLinkFailureDescription:
          '返回到<a>记者中心</a>再试一次。如果问题持续发生，请通过<mailto>techsupport@vaultplatform.com</mailto>联系我们。',
        sendLinkSuccess: '已发送密码重置链接',
        sendLinkSuccessDescription: '我们已向{{email}}发送了密码重置链接',
        updatePasswordSuccess: '密码已更新',
        updatePasswordSuccessDescription:
          '您的密码已成功更新。感谢您采取此步骤保护您的数据安全！',
      },
      ReportingLogin: {
        accountFrozen: '账户已冻结',
        accountLocked:
          '尝试登录的次数过多，账户已被锁定长达1小时。在此期间，无法重置密码。',
        accountLockedPermanently:
          '您的账户已被锁定。使用重置密码来重新获取访问权限，或联系您的系统管理员以获取进一步的帮助。',
        createAccountCTA: '注册一个账户',
        currentPassword: '当前密码',
        emailLabel: '您的电子邮件',
        forgotPassword: '忘记了您的密码？',
        loginButton: '登录',
        newPasswordPlaceholder: '新密码',
        passwordFailMessage:
          '返回Slack中的Vault应用程序，然后再试一次。如果问题仍然存在，请通过techsupport@vaultplatform.com与我们联系。',
        passwordFailTitle: '出了些问题',
        passwordLabel: '您的密码',
        passwordPlaceholder: '输入你的密码',
        passwordResetRequired: '需要重置密码',
        passwordSuccessfullySetMessage:
          '回到Slack中的Vault App，并使用您的新密码进行验证，以继续您之前的操作。',
        passwordSuccessfullySetTitle: '密码设置成功',
        reenterPlaceholder: '重新输入密码',
        title: '记者中心',
        tooltip:
          '如果您还没有为Vault应用设置密码，可按照此处的指示开始。如果您忘记了密码，请使用下面的"忘记密码"链接。',
        usernameLoginFailed: '登录失败，用户名或密码不正确',
      },
      ReportingReset: {
        failureDescription:
          '返回到Slack中的Vault应用程序并再试一次。如果问题仍然存在，请通过<mailto>techsupport@vaultplatform.com</mailto>联系我们。',
        failureHeading: '出了些问题',
        successDescription:
          '回到Slack中的Vault应用程序，使用您的新密码进行验证，然后继续之前的操作。',
        successHeading: '密码设置成功',
      },
      noReports: {
        description:
          '所有提交的报告都会在这里显示。了解更多关于你提交报告的方式 Vault。',
        descriptionHelpArticle: '这篇帮助文章',
        errorDescription: '我们正在努力加载您的报告。请尝试刷新页面。',
        errorDescriptionSecondary: '如果那样做不起作用，请联系我们在',
        errorTitle: '⚠️ 哎呀，出错了',
        title: '您还没有报告',
      },
      settings: {
        messageSettings: {
          autoTranslationDescription1:
            '启用自动翻译，并以您偏爱的语言阅读所有报告消息。翻译的语言是基于您设备上选择的语言。',
          autoTranslationDescription2:
            '您可以在每个聊天中切换翻译语言和原始语言。',
          autoTranslationTitle: '启用报告消息的自动翻译功能',
          header: '消息设置',
          subHeader: '配置消息的显示方式',
        },
        notificationSettings: {
          emailDescription: '接收电子邮件通知，了解您报告的重要更新',
          emailTitle: '电子邮件通知',
          header: '通知设置',
          subHeader: '配置您如何接收通知',
        },
        title: '设置',
        updatedSettingsFailure: '更新您的设置失败',
        updatedSettingsSuccess: '成功更新了您的设置',
      },
    },
    validators: {
      passwordLength: '密码必须至少有 9 个字符',
      passwordLowercase: '密码必须至少包含 1 个小写字母',
      passwordMissMatch: '密码和确认字段必须匹配。',
      passwordNumeric: '密码必须至少包含 1 个数字',
      passwordUppercase: '密码必须至少包含 1 个大写字母',
    },
    validatorsNew: {
      passwordLength: '在10到30个字符之间',
      passwordLowercase: '至少一个小写字母',
      passwordMissMatch: '密码不匹配',
      passwordNumeric: '至少一个数字',
      passwordSpecialCharacter: '至少一个特殖字符',
      passwordUppercase: '至少一个大写字母',
    },
  },
};

export default translations;
